import { render, staticRenderFns } from "./contactForm.vue?vue&type=template&id=1296a57f&scoped=true"
import script from "./contactForm.vue?vue&type=script&lang=js"
export * from "./contactForm.vue?vue&type=script&lang=js"
import style0 from "./contactForm.vue?vue&type=style&index=0&id=1296a57f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296a57f",
  null
  
)

export default component.exports